export const LedgerWalletKey = "orderly:ledger-wallet";
export const LedgerWalletManualOverrideKey =
  "orderly:ledger-wallet-manual-override";
export const ConnectorKey = "orderly:connectorKey";
export const ChainKey = "order:chain";
export const LinkDeviceKey = "orderly_link_device";
export const TradingviewFullscreenKey = "orderly:tradingview-fullscreen";
export const OrderEntrySortKeys = "orderly:order_entry_sort_keys";
